/** @type {import('../schema').ProcessDefinition} */
const centroComando = {
  id: "centro-comando",
  name: "Centro de comando",
  category: "operaciones",
  outcome:
    "Visibilidad operativa en tiempo real (cobranza, incidencias, gastos) con semáforo por edificio.",
  trigger: "El Administrador/Super Admin abre Centro de comando.",
  actors: ["Sistema", "Administrador", "Super Admin"],
  status: "COMPLETO",
  description:
    "El sistema carga los KPIs (cobranza del mes, morosidad, incidencias críticas/SLA, gastos), aplica un semáforo verde/amarillo/rojo por edificio según umbrales, y el admin entra al detalle de un edificio. La exportación de reportes sería mejora.",
  lanes: [
    { id: "sys", actor: "Sistema" },
    { id: "admin", actor: "Administrador" },
    { id: "sadmin", actor: "Super Admin" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Abre el Centro de comando", description: "El Administrador o Super Admin entra al tablero.", evidence: "src/screens/admin/CentroComando.jsx" },
    { id: "s2", laneId: "sys", type: "task", label: "Carga los KPIs", description: "Cobranza del mes, morosidad, incidencias críticas/SLA y gastos.", evidence: "src/utils/kpiCalculations.js" },
    { id: "s3", laneId: "sys", type: "decision", label: "¿Hay datos del período?" },
    { id: "s4", laneId: "sys", type: "document", label: "Calcula el semáforo por edificio", description: "Verde/amarillo/rojo según umbrales de criticidad.", evidence: "src/utils/kpiCalculations.js" },
    { id: "s5", laneId: "sys", type: "end", label: "Muestra tarjetas vacías", description: "Sin datos en el período no hay indicadores." },
    { id: "s6", laneId: "admin", type: "decision", label: "¿Edificio en rojo/amarillo?" },
    { id: "s7", laneId: "admin", type: "task", label: "Drilldown al detalle del edificio", description: "Entra al detalle para actuar sobre la alerta.", evidence: "src/screens/admin/CentroComando.jsx" },
    { id: "s8", laneId: "admin", type: "end", label: "Operación monitoreada" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "sí" },
    { from: "s3", to: "s5", label: "no" },
    { from: "s4", to: "s6" },
    { from: "s6", to: "s7", label: "requiere acción" },
    { from: "s6", to: "s8", label: "todo verde" },
    { from: "s7", to: "s8" },
  ],
};

export default centroComando;
